// extracted by mini-css-extract-plugin
export default {"section":"styles_section__frhg7","icon":"styles_icon__59EWd","heading":"styles_heading__UHbkE","para":"styles_para__3zOWr"};